import script from "./LeagueDescriptions.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueDescriptions.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueDescriptions.vue?vue&type=style&index=0&id=bac67952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bac67952"]])

export default __exports__